import { useEffect, useState, useLayoutEffect, useRef } from 'react';

export default function Test() {
/*  const [count, setCount] = useState(0);
  useEffect(() => {
    console.log('useEffect is fired');
    //Side effect
  }, [count]);

return(
 <div>
    <h1>Count: {count} </h1>
    <button onClick={() => setCount(count + 1)}>Increment count</button>
 </div>
 ) */

 const [showToolTip, setShowTooltip] = useState(false);
 const buttonRef = useRef();
 const tooltipRef = useRef();

 useLayoutEffect(() => {
   if (buttonRef.current == null || tooltipRef.current == null) return;

   const { left, top } = buttonRef.current.getBoundingClientRect();
   tooltipRef.current.style.left = `${left + 120}px`;
   tooltipRef.current.style.top =  `${top - 20}px`;
 }, [showToolTip]);

 return (
   <div>
     <button ref={buttonRef}
       onClick={() => setShowTooltip(prevState => !prevState)}>
       Toggle tooltip
     </button>

     {showToolTip &&
       (<div ref={tooltipRef} 
       style=
       {{ position: 'absolute', 
          border: '1px solid gray', 
          padding: '20px', 
          backgroundColor: 'lightgray'
       }}
       >
         This is a Tooltip!
       </div>)}
   </div>
 )
}